export const actions = {
    FETCH_ALL_JIRA_USERS: 'FETCH_ALL_JIRA_USERS',
    FETCH_ALL_JIRA_USERS_PENDING: 'FETCH_ALL_JIRA_USERS_PENDING',
    FETCH_ALL_JIRA_USERS_FULFILLED: 'FETCH_ALL_JIRA_USERS_FULFILLED',
    FETCH_ALL_JIRA_USERS_REJECTED: 'FETCH_ALL_JIRA_USERS_REJECTED',
};

export default (state = {
                        jiraUsers: null,
                        jiraUsersIsFetching: false,
                    }, action) => {

    state = {...state};

    switch (action.type) {
        case actions.FETCH_ALL_JIRA_USERS_PENDING:
            state.jiraUsersIsFetching = true;
            return state;
        case actions.FETCH_ALL_JIRA_USERS_FULFILLED:
            state.jiraUsers = sortJiraUsers(action.payload.data.data);
            state.jiraUsersIsFetching = false;
            return state;
        case actions.FETCH_ALL_JIRA_USERS_REJECTED:
            state.jiraUsers = null;
            state.jiraUsersIsFetching = false;
            return state;

        default:
            return state;
    }
};

const sortJiraUsers = (data) => {
    if(data && data.length === 0) {
         return null
     }
    return data.sort((a, b) =>  a.firstName?.localeCompare(b?.firstName));
};



// WEBPACK FOOTER //
// ./app/reducers/jira.ts